import Props from "./props";
import React from "react";
import Styled from "./styled";
import refactorProps from "../../../../helpers/refactorProps";

const Button: React.FC<Props> = ({ children, type = "button", uppercase, shadow, primary, light, isLoading, onClick }) => {
    return <Styled {...refactorProps({ type, uppercase, shadow, primary, light, isLoading, onClick })}>{children}</Styled>;
};

export default Button;
